/*
 * The English landing URLs (`/en/…`, Decision 112). They are shown in English for that page view only: the visitor's
 * stored language (`cardnd.lang`) is never written. A language the visitor picks there is stored as usual; French
 * then opens the page's French URL. Every other page keeps one URL in French (Decisions 19, 95).
 */
import { useLayoutEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { frenchPathOf } from '@/features/landing/cities';
import { setPageLocale, useLocale } from '@/i18n';
import { paths } from './paths';

export function EnglishPages() {
  const { pathname } = useLocation();
  // Once, before the page renders, so its first render is already English.
  useState(() => setPageLocale('en', { silent: true }));
  const locale = useLocale();

  useLayoutEffect(() => {
    setPageLocale('en');
    return () => setPageLocale(null);
  }, []);

  // The visitor picked French on the page.
  if (locale !== 'en') return <Navigate replace to={frenchPathOf(pathname) ?? paths.home} />;
  return <Outlet />;
}
